<template>
  <div>
    <v-client-table :columns="columns" :data="devicesWithId" :options="options" :theme="theme" id="dataTable">
      <div slot="afterLimit" class="card-header-actions">
        <download-excel
          class   = "btn btn-default"
          type    = "csv"
          name    = "devices.xls"
          :data   = "devicesToCsv">
            <i class="fa fa-file-excel-o"></i>
        </download-excel>
      </div>
      <div slot="id" slot-scope="props">
        <router-link :to="{name: 'Device', params: {id: props.row.id}}">{{props.row.id}}</router-link>
      </div>
      <b-button pill variant="outline-light" size="sm" slot="delete" slot-scope="props" @click.stop="confirmDelete(props.row)">
        <i class="fa fa-trash"></i>
      </b-button>
      <b-button :href='"https://www.google.com/maps/search/?api=1&query=" + props.row.location.latitude + "," + props.row.location.longitude' 
        pill variant="outline-light" size="sm" slot="location" slot-scope="props"
        target="_blank"
        v-if="props.row.location && props.row.location.latitude && props.row.location.longitude">
          <i class="fa icon-map"></i>
      </b-button>
      <div slot="isStolen" slot-scope="props">
        <b-button pill :variant="props.row.isStolen === true ? 'danger': 'info'" size="sm"  @click.stop="confirmStolen(props.row)">
          {{props.row.isStolen === true ? "Cancel Stolen": "Mark Stolen"}}
        </b-button>
      </div>
      <div slot="child_row" slot-scope="props">
        Device ID : {{props.row.id}}
      </div>
    </v-client-table>

    <b-modal title="Warning" class="modal-warning" v-model="warningModal" @ok="deleteItem" ok-variant="warning">
      Users related this device also will be affected?  Are you sure to delete?
    </b-modal>

    <b-modal title="Info" class="modal-warning" v-model="toggleStolenModal" @ok="toggleStolen" ok-variant="warning">
      Are you sure to change STOLEN status?
    </b-modal>
  </div>
</template>

<script>
  import { ClientTable, Event } from 'vue-tables-2'

  export default {
    name: 'Devices',
    components: {
      ClientTable,
      Event
    },
    props: {
      ownedBy: {
        type: String,
        required: false
      },
      searchOption: {
        type: Object,
        required: false,
      }      
    },
    data: function() {
      return {
        selectedItem: null,
        idToDelete : null,
        warningModal: false,
        toggleStolenModal : false,
        devices: null,
        columns: ['id', 'model', 'scanTime', 'ownedBySize', 'isStolen', 'created', 'updated', 'location', 'delete'],
        options: {
          headings: {
            id: 'Serial No',
            model: 'Model',
            scanTime: 'Scan Time',
            ownedBySize: 'Users',
            isStolen: 'Stolen',
            created: 'Created',
            updated: 'Updated',
            location: 'Location',
            delete: 'Delete'
          },
          sortable: ['model', 'id', 'scanTime', 'ownedBySize', 'isStolen', 'created', 'updated'],
          filterable: ['model', 'id', 'scanTime', 'ownedBySize', 'isStolen', 'created', 'updated',],
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          templates: {
            created: (h, row, index) => {
                return (row.created && row.created.seconds) ?this.$moment.unix(row.created.seconds).format('YYYY-MM-DD HH:mm:ss'): '';
            },
            updated: (h, row, index) => {
                return (row.updated && row.updated.seconds) ?this.$moment.unix(row.updated.seconds).format('YYYY-MM-DD HH:mm:ss'): '';
            }
          },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default'
      }
    },
    created: function() {
      let query = this.$firebase.firestore().collection('devices')

      if (this.ownedBy) {
        query = query.where('ownedBy', 'array-contains', this.$firebase.firestore().collection('users').doc(this.ownedBy))
      } 
      if (this.searchOption) {
        if (typeof this.searchOption.stolen === 'boolean') {
          query = query.where('isStolen', '==', this.searchOption.stolen)
        }
        if (this.searchOption.registered === false) {
          query = query.where('ownedBySize', '==', 0)
        }
        if (this.searchOption.createdFrom && this.searchOption.createdTo) {
          query = query
          .where('created', '>=', this.$moment(this.searchOption.createdFrom, 'YYYY-MM-DD').startOf('day').toDate())
          .where('created', '<=', this.$moment(this.searchOption.createdTo, 'YYYY-MM-DD').endOf('day').toDate())
        }
      }
      query = query.orderBy('created', 'desc').limit(1000)
      this.$bind('devices', query)
    },
    computed: {
        devicesWithId() {
            if (!this.devices || this.devices.length < 1) {
                return []
            }
            return this.devices.map(device => {
                return {...device, id: device.id}
            })
        },
        devicesToCsv() {
            if (!this.devices || this.devices.length < 1) {
                return []
            }
            return this.devices.map(device => {
              const newDevice = {...device, id: device.id}
              if (newDevice.location) newDevice.location = newDevice.location.latitude + ',' + newDevice.location.longitude
              delete newDevice.ownedBy;
              return newDevice;
            })
        }
    },
    methods: {
        confirmStolen(item, event) {
          if (!item) {
            return
          }
          this.selectedItem = item
          this.idToDelete = item.id
          this.toggleStolenModal = true
        },
        confirmDelete(item) {
          if (!item) {
            return
          }
          this.idToDelete = item.id
          this.warningModal = true
        },
        toggleStolen() {
          if (!this.idToDelete) return
          this.$firebase.firestore().collection('devices').doc(this.idToDelete).update({isStolen: this.selectedItem.isStolen === true ? false: true})
          .catch(error => {
            console.error('update stolen status error : ', error)
          })
          this.toggleStolenModal = false
        },
        deleteItem() {
          if (!this.idToDelete) return

          this.$firebase.firestore().collection('devices').doc(this.idToDelete).delete()
          .catch(error => {
            console.error('delete error: ', error)
          })
          this.warningModal = false
        }
    }
  };
</script>

<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

  .icon-map {
    color: blue;
  }
</style>
